// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"202":"9a99e316","241":"9c783c75","281":"84e7c974","587":"28e5255e","877":"e98a9920"}[chunkId] + ".chunk.css";
};